import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BASE_LMSA_URL, DEFAULT_MERCHANT_NO } from '../../app.constants';
import { createRequestOption, getFormateDate } from '../util/request-util';
import { Router } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
// import * as DigestFetch from 'digest-fetch';
import DigestFetch from '../../../authjs/digest-fetch-api'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  redirectToActualURL : string | null = null;
  getAuthenticationState(): any {
    throw new Error('Method not implemented.');
  }
  hasAnyAuthority(authorities: string | string[]) {
    // throw new Error('Method not implemented.');
    return ['TEST']
  }
  isLoggedIn: boolean = false;
  userLoginId: string;
  // store the URL so we can redirect after logging in
  public redirectUrl: string;

  isUserAuthenticated = new EventEmitter<any>();

  public userDigestAuth: any = null;

  private initLoginOTPUrl = BASE_LMSA_URL + 'public/api/0.9/json/customer/generate-otp';
  private submitLoginOTPUrl = BASE_LMSA_URL + 'public/api/0.9/json/validate/session/otp';
  private userAuthUrl = BASE_LMSA_URL + 'api/0.9/json/user/authenticate';
  private registerUrl = BASE_LMSA_URL + 'api/0.9/json/user/customer/register';
  private generateOTPUrl = BASE_LMSA_URL + 'api/0.9/json/user/forgotpassword/generateotp';
  private validateOTPUrl = BASE_LMSA_URL + 'api/0.9/json/user/forgotpassword/validate';
  private validateUser = BASE_LMSA_URL + 'api/0.9/json/user/customer/register/validate?';
  private dupEmailCheckUrl = BASE_LMSA_URL + 'public/api/0.9/json/user/duplicate/check';




  constructor(protected http: HttpClient, public storage: StorageMap, private router: Router) {
    this.checkForAuth().subscribe(
      res => { console.log(res) },
      err => { console.log(err) }
    );
    this.storage.get('isLoggedin').subscribe((res: any) => {
      console.log(res)
      this.isLoggedIn = res;
    });

  }


  loadCodedValueMap() {
    return new Observable((observable) => {
      if (this.userDigestAuth != null) {
        observable.next('authenticated');
      } else {
        this.storage.get('auth').subscribe((res: any) => {
          if (res && res.username) {
            this.initAuth(res.username, res.h1Token);
            observable.next('authenticat');
            this.isUserAuthenticated.emit(true);
          } else {
            observable.next('not - authenticat');
            this.isUserAuthenticated.emit(false);
          }
        }, err => {
          observable.error('not-authenticated');
          this.isUserAuthenticated.emit(false);
        });
      }
    });
  }


  doLogout() {
    this.isUserAuthenticated.next(false)
    this.userDigestAuth = null;
    this.storage.clear().subscribe(
      res => {
        this.router.navigate(['/']);
      },
      err => {
        console.log('nout')
      }
    )
  }

  async checkForAuthAsync() {
    return new Promise(async (resolve) => {
        this.checkForAuth().subscribe(
          res => {
            resolve(res);
          }
        )
    });
  }

  checkForAuth() {
    return new Observable((observable) => {
      if (this.userDigestAuth != null) {
        observable.next('authenticated');
        this.isUserAuthenticated.emit(true);
      } else {
        this.storage.get('auth').subscribe((res: any) => {
          if (res && res.username) {
            this.initAuth(res.username, res.authentication);
            observable.next('authenticat');
            this.isUserAuthenticated.emit(true);
            this.userLoginStatusUpdate(true);

          } else {
            observable.next('not - authenticat');
            this.isUserAuthenticated.emit(true);
            this.userLoginStatusUpdate(false);
            this.router.navigate(['/auth/login']);
          }
        }, err => {
          observable.error('not-authenticated');
          this.isUserAuthenticated.emit(true);
          this.userLoginStatusUpdate(false);

        });
      }
    });
  }

  userLoginStatusUpdate(isLoggedin) {
    if (isLoggedin) {
      this.isLoggedIn=true;
    } else {
      let redirectUrl = window?.location?.hash;
      redirectUrl = redirectUrl.replace('#', '')
      if(redirectUrl && redirectUrl !== '/auth/login') {
        this.redirectToActualURL = redirectUrl;
      }
      this.router.navigate(['/auth/login']);
      this.isLoggedIn=false;
    }
  }
  getUserdetail() {
    const headers = { "X-Requested-With": "XMLHttpRequest", "ngBrowserVersion": "true" };
    const factory = () => ({ method: 'GET', headers });
    const options = { factory }

    return new Observable((observable) => {

      if (!this.userDigestAuth) {
        observable.error('not authenticated');
        this.isUserAuthenticated.emit(false);
      }
      this.userDigestAuth.fetch(this.userAuthUrl, options)
        .then(resp => resp.json())
        .then(data => {
          observable.next(data);
        })
        .catch(e => {
          observable.error(e);
        });
    });
  }


  setAuthDetailInIndexedDBAndInitAuth(authReq: any) {
    if (authReq) {
      this.initAuth(authReq.username, authReq.authentication);
      // this.storage.set('auth', authReq).subscribe(() => {
      // });
    }
  }

  initAuth(userName: string, h1Token: string) {
    // if (password) {
    //   this.userDigestAuth = new DigestFetch(userName, password, { algorithm: 'MD5', basic: false, statusCode: 403 });
    // } else {
    //   this.userDigestAuth = new DigestFetch(userName, h1Token, { precomputedHash: true, algorithm: 'MD5', basic: false, statusCode: 403 });
    // }

    this.userDigestAuth = new DigestFetch(userName, h1Token, { precomputedHash: true, algorithm: 'MD5', basic: false, statusCode: 403 });
  }

  convertPasswordAndGetMd5(user, password) {
    return DigestFetch.computeHash(user, 'user@inspirenetz.com', password);
  }

  initOTPRequest(req: any): Observable<any> {
    const option = createRequestOption(req);
    return this.http.post(this.initLoginOTPUrl, {}, { params: option, observe: 'response' });
  }

  submitOTP(req: any): Observable<any> {
    const option = createRequestOption(req);
    return this.http.post(this.submitLoginOTPUrl, {}, { params: option, observe: 'response' });
  }

  registerUser(req: any): Observable<any> {
    const copy = this.convertDateFormatClient(req);
    return this.http.post(this.registerUrl, copy, { observe: 'response' });
  }

  protected convertDateFormatClient(requst: any) {
    const copy: any = Object.assign({}, requst, {
      cspCustomerBirthday: getFormateDate(requst.cspCustomerBirthday)
    });
    return copy;
  }

  generateOTP(req: any) {

    const option = createRequestOption(req);

    return this.http.post(this.generateOTPUrl, {}, { params: option, observe: 'response' });
  }

  validateOTP(req: any) {
    const option = createRequestOption(req);
    return this.http.post(this.validateOTPUrl, {}, { params: option, observe: 'response' });
  }

  validateRegisteredUser(uid: any, merchantNo: any) {
    return this.http.post(this.validateUser + 'uid=' + uid + '&&merchantNo=' + merchantNo, {}, { observe: 'response' });
  }

  checkDuplicateEmail(countryCode: any, email: string) {
    return this.http.get(this.dupEmailCheckUrl + '?usrMobile=' + countryCode + '&usrEmail=' + email + '&merchantNo=' + DEFAULT_MERCHANT_NO, { observe: 'response' });
  }

  // getMenuUserAccess(req?:any) {
  //   return this.http.get(this.userAccessUrl, { observe: 'response' });
  // }

}
